<template>
  <v-container fluid>
    <template>
      <v-breadcrumbs :items="link">
        <template v-slot:link="{ link }">
          <v-breadcrumbs-item :href="link.href" :disabled="link.disabled">
            {{ link.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </template>

    <template>
      <v-banner color="#fff" elevation="1" tile>
        <v-spacer></v-spacer>
        <v-row align="right" justify="end">
          <v-btn
           
            class="ma-3 "
            :loading="loading ? '#0482fb' : null"
            :disabled="loading"
            color="red"
            pill
            @click="appelsModal = true"
          >
            Programmer Appel
          </v-btn>
          <v-btn
           
            class="ma-3"
            :loading="loading ? '#0482fb' : null"
            :disabled="loading"
            color="warning"
            pill
            @click="appointmentDialog = true"
          >
            Programmer rendez-vous
          </v-btn>
          <v-btn
           
            class="ma-3"
            :loading="loading ? '#0482fb' : null"
            :disabled="loading"
            color="#0482fb"
            pill
            @click="productDialog = true"
          >
            Gestion produits
          </v-btn>
          <v-btn
           
            class="ma-3"
            :loading="loading ? '#0482fb' : null"
            :disabled="loading"
            color="secondary"
            pill
            @click="CotationDialog = true"
          >
            Demande cotation
          </v-btn>
        </v-row>
      </v-banner>
    </template>
    <template>
      <h2 class="mt-5 mb-5 ml-4">Informations clients</h2>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                color="#0482fb"
                v-model="File.name"
                label="Nom / Raison sociale"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                color="#0482fb"
                v-model="File.phone"
                label="Téléphone"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                color="#0482fb"
                v-model="File.activityField"
                disabled
                label="Domaine d'activité"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                color="#0482fb"
                v-model="File.email"
                disabled
                label="Mail"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                color="#0482fb"
                v-model="File.location"
                disabled
                label="Localité"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                color="#0482fb"
                v-model="File.nature"
                disabled
                label="Nature"
              ></v-text-field>
            </v-col>
            <v-col v-if="File.birthday" cols="12" md="4">
              <v-text-field
                outlined
                color="#0482fb"
                :value="File.birthdayFr"
                disabled
                label="Date d'anniversaire"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" md="4">
              <v-text-field outlined  
            color="#0482fb"
                disabled
                v-model="firstName"
                label="Autres détaille ..."
              ></v-text-field>
            </v-col> -->
            <v-container class="d-none" fluid>
              <v-textarea
                outlined
                autocomplete="email"
                disabled
                v-model="File.observation"
                label="Observation relative au dossier"
              ></v-textarea>
            </v-container>
          </v-row>
        </v-container>
      </v-form>
    </template>
    <template>
      <v-card-title>
        Correspondants
        <v-spacer></v-spacer>
        <v-text-field
          outlined
          color="#0482fb"
          v-model="search"
          append-icon="mdi-magnify"
          label="Recherche"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="File.prospects"
        :search="search"
      ></v-data-table>
    </template>
    <!-- Cotation listing -->
    <v-dialog v-model="CotationDialog" max-width="1000px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h6"
            >Adresser une demande à la Direction Technique</span
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  outlined
                  :items="proposedProductNameList"
                  v-model="product"
                  label="Nom du produit"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="usersEmail"
                  :items="userNameList"
                  label="Notification Cotation"
                  multiple
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      <v-avatar
                        class="accent white--text"
                        left
                        v-text="data.item.slice(0, 1).toUpperCase()"
                      ></v-avatar>
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  v-model="observation"
                  label="Observations"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
           
            color="error darken-1"
            :disabled="loading"
            text
            @click="CotationDialog = false"
          >
            Fermer
          </v-btn>
          <v-btn
           
            color="success darken-1"
            :loading="loading"
            @click="saveQuotingRequest"
          >
            Adresser Demande cotation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  Pop up des appels-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog
            v-model="appelsModal"
            overlay
            max-width="1000px"
            transition="dialog-bottom-transition"
            scrollable
          >
            <v-card style="border-top: 10px solid #0482fb" tile>
              <v-card-text>
                <v-row class="fill-height">
                  <v-col>
                    <v-sheet height="64">
                      <v-toolbar flat>
                        <v-btn
                          
                          class="mr-4"
                          color="grey darken-2"
                          @click="setToday"
                        >
                          Aujourd'hui
                        </v-btn>
                        <v-btn
                          
                          fab
                          text
                          small
                          color="grey darken-2"
                          @click="prev"
                        >
                          <v-icon small> mdi-chevron-left </v-icon>
                        </v-btn>
                        <v-btn
                          
                          fab
                          text
                          small
                          color="grey darken-2"
                          @click="next"
                        >
                          <v-icon small> mdi-chevron-right </v-icon>
                        </v-btn>
                        <v-toolbar-title v-if="$refs.calendar">
                          {{ $refs.calendar.title }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-menu bottom right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              
                              color="grey darken-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <span>{{ typeToLabel[type] }}</span>
                              <v-icon right> mdi-menu-down </v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="type = 'day'">
                              <v-list-item-title>Day</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'week'">
                              <v-list-item-title>Week</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'month'">
                              <v-list-item-title>Month</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = '4day'">
                              <v-list-item-title>4 Days</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-btn
                          
                          color="success"
                          pill
                          class="ml-5"
                          @click="(callDialog = true), (editedIndex = -1)"
                        >
                          <v-icon left> mdi-pencil </v-icon>
                          Nouvel Appel
                        </v-btn>
                      </v-toolbar>
                    </v-sheet>
                    <v-sheet height="600">
                      <v-calendar
                        ref="calendar"
                        v-model="focus"
                        color="primary"
                        :events="events"
                        :event-color="getEventColor"
                        :type="type"
                        @click:event="showCallEvent"
                        @click:more="viewDay"
                        @click:date="viewDay"
                        @change="getCallEvent"
                      ></v-calendar>
                      <v-menu
                        v-model="selectedOpen"
                        :close-on-content-click="false"
                        :activator="selectedElement"
                        offset-x
                      >
                        <v-card color="grey lighten-4" flat>
                          <v-toolbar :color="selectedEvent.color" dark>
                            <v-btn  icon>
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-toolbar-title
                              v-html="selectedEvent.name"
                            ></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn  icon>
                              <v-icon>mdi-heart</v-icon>
                            </v-btn>
                            <v-btn  icon>
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </v-toolbar>
                          <v-card-text>
                            <span v-html="selectedEvent.details"></span>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              
                              text
                              color="secondary"
                              @click="selectedOpen = false"
                            >
                              Cancel
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!--  Pop up des Rendez vous-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog
            v-model="appointmentDialog"
            overlay
            transition="dialog-bottom-transition"
            scrollable
            max-width="1000px"
          >
            <v-card style="border-top:10px solid #0482fb">
              <v-card-text>
                <v-row class="fill-height">
                  <v-col>
                    <v-sheet height="64">
                      <v-toolbar flat>
                        <v-btn
                          
                          class="mr-4"
                          color="grey darken-2"
                          @click="setTodays"
                        >
                          Aujourd'hui
                        </v-btn>
                        <v-btn
                          
                          fab
                          text
                          small
                          color="grey darken-2"
                          @click="prevs"
                        >
                          <v-icon small> mdi-chevron-left </v-icon>
                        </v-btn>
                        <v-btn
                          
                          fab
                          text
                          small
                          color="grey darken-2"
                          @click="nexts"
                        >
                          <v-icon small> mdi-chevron-right </v-icon>
                        </v-btn>
                        <v-toolbar-title v-if="$refs.calendars">
                          {{ $refs.calendars.title }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-menu bottom right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              
                              color="grey darken-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <span>{{ typeToLabel[types] }}</span>
                              <v-icon right> mdi-menu-down </v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="types = 'day'">
                              <v-list-item-title>Jours</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="types = 'week'">
                              <v-list-item-title>Semaine</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="types = 'month'">
                              <v-list-item-title>Mois</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="types = '4day'">
                              <v-list-item-title>4 Jours</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-btn
                          
                          color="success"
                          class="ml-5"
                          pill
                          @click="
                            (appointmentAddDialog = true), (editedIndex = -1)
                          "
                        >
                          <v-icon left> mdi-pencil </v-icon>
                          Nouveau rendez-vous
                        </v-btn>
                      </v-toolbar>
                    </v-sheet>
                    <v-sheet height="600">
                      <v-calendar
                        ref="calendars"
                        v-model="focuss"
                        color="primary"
                        :events="appointmentEvents"
                        :event-color="getEventColor"
                        :type="types"
                        @click:event="showAppointmentEvent"
                        @click:more="viewDays"
                        @click:date="viewDays"
                        @change="getAppointmentEvent"
                      ></v-calendar>
                      <v-menu
                        v-model="selectedOpen"
                        :close-on-content-click="false"
                        :activator="selectedElement"
                        offset-x
                      >
                        <v-card color="grey lighten-4" flat>
                          <v-toolbar :color="selectedEvent.color" dark>
                            <v-btn  icon>
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-toolbar-title
                              v-html="selectedEvent.name"
                            ></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn  icon>
                              <v-icon>mdi-heart</v-icon>
                            </v-btn>
                            <v-btn  icon>
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </v-toolbar>
                          <v-card-text>
                            <span v-html="selectedEvent.details"></span>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              
                              text
                              color="secondary"
                              @click="selectedOpen = false"
                            >
                              Cancel
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!--  Pop up des produits-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog
            v-model="productDialog"
            overlay
            transition="dialog-bottom-transition"
            scrollable
            max-width="1000px"
          >
            <v-card style="border-top: 10px solid #0482fb">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <h3 class="mt-5 ml-2">Liste des produits</h3>
                    <v-text-field
                      outlined
                      color="#0482fb"
                      label="Recherche"
                      class="pt-5 "
                      prepend-inner-icon="mdi-magnify"
                      dense
                      v-model="searchData"
                      @change="searchDataProduct"
                      flat
                      background-color="grey lighten-4"
                    ></v-text-field>

                    <v-data-table
                      v-model="selectedProduct"
                      :headers="headersProduct"
                      :items="Products.docs"
                      :items-per-page="5"
                      item-key="name"
                      show-select
                    >
                    </v-data-table>
                    <div class="mt-5">
                      <v-btn
                        
                        color="#0482fb"
                        pill
                        @click="updateProposedProduct"
                        ><v-icon left> mdi-pencil </v-icon>Proposer les produits
                        selectionnés au Prospect</v-btn
                      >
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <h3 class="mt-5 ml-2">Liste des produits proposés</h3>

                    <v-data-table
                      :headers="headersProposedProduct"
                      :items="File.proposedProducts"
                      class="mt-4"
                      :items-per-page="5"
                    >
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!--  Pop up des cotation-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog
            v-model="quotingDialog"
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
          >
            <v-card tile>
              <v-toolbar flat dark color="#0482fb">
                <v-btn
                  
                  icon
                  dark
                  @click="dialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title
                  >DAYO - IARD / Prospection / Cotation</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-row align="center" justify="space-around">
                    <v-btn
                      
                      tile
                      color="success"
                      class="mr-10"
                      @click="saveQuoting"
                    >
                      <v-icon left> mdi-pencil </v-icon>
                      Enregistrer
                    </v-btn>
                  </v-row>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <h2 class="pt-8 pl-3">Informations de cotation pour client</h2>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12">
                      <v-combobox
                        v-model="quotingModal.companies"
                        :items="companyNameList"
                        label="Sélectionner les compagnie"
                        multiple
                        chips
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            @click:close="data.parent.selectItem(data.item)"
                          >
                            <v-avatar
                              class="accent white--text"
                              left
                              v-text="data.item.slice(0, 1).toUpperCase()"
                            ></v-avatar>
                            {{ data.item }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container fluid>
                  <v-row align="center">
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="quotingModal.duration"
                        label="Durée"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="quotingModal.netPrime"
                        label="Prime nette"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="quotingModal.TTCPrime"
                        label="Prime TTC"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="quotingModal.dateReturnCustomer"
                        type="date"
                        label="Retour client"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="quotingModal.annualRent"
                        type="number"
                        label="Loyer Annuel"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="quotingModal.turnover"
                        type="number"
                        label="Chiffre d'affaire"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="quotingModal.effective"
                        type="number"
                        label="Effectif"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="quotingModal.quality"
                        type="number"
                        label="Qualité"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="quotingModal.payroll"
                        type="number"
                        label="Masse salariale"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="quotingModal.siteType"
                        type="number"
                        label="Type de chantier"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-textarea
                        outlined
                        v-model="quotingModal.observation"
                        name="input-7-4"
                        label="Observation sur cotation"
                        value=""
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!--  Pop up des Garantie-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog
            v-model="garantie"
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
          >
            <v-card tile>
              <v-toolbar flat dark color="#0482fb">
                <v-btn
                  
                  icon
                  dark
                  @click="dialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title
                  >DAYO - IARD / Production / Tableau des
                  garantie</v-toolbar-title
                >
                <v-menu bottom right offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      
                      dark
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, i) in items"
                      :key="i"
                      @click="() => {}"
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
              <v-card-text class="pt-25">
                <v-tabs v-model="tab">
                  <v-tab v-for="item in garantietitre" :key="item.tab">
                    {{ item.tab }}
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item v-for="item in garantietitre" :key="item.tab">
                    <v-card flat>
                      <div>
                        <div class="text-center d-flex pb-4 pt-8">
                          <v-btn
                            
                            @click="all"
                            class="mr-8"
                          >
                            all
                          </v-btn>
                          <v-btn  @click="none">
                            none
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-row align="center" justify="space-around">
                              <v-btn
                                
                                tile
                                color="success"
                                class="mr-12"
                                @click="addgarantie = true"
                              >
                                <v-icon left> mdi-pencil </v-icon>
                                Responsabilité Civile Exploitation
                              </v-btn>
                            </v-row>
                          </v-toolbar-items>
                          <v-toolbar-items>
                            <v-row align="center" justify="space-around">
                              <v-btn
                                
                                tile
                                color="success"
                                class="mr-12"
                                @click="addgarantie = true"
                              >
                                <v-icon left> mdi-pencil </v-icon>
                                Responsabilité Civile Professionnelle
                              </v-btn>
                            </v-row>
                          </v-toolbar-items>
                        </div>
                        <v-row align="center">
                          <v-col class="d-flex" cols="12" sm="4">
                            <v-banner shaped
                              >CONDITIONS GENERALES DE GARANTIES</v-banner
                            >
                          </v-col>
                          <v-col class="d-flex" cols="12" sm="4">
                            <v-banner shaped>Capitaux (FCFA)</v-banner>
                          </v-col>
                          <v-col class="d-flex" cols="12" sm="4">
                            <v-banner shaped>Franchise (FCFA)</v-banner>
                          </v-col>
                        </v-row>
                        <v-expansion-panels v-model="panel" multiple>
                          <v-expansion-panel
                            v-for="item in categoriegarantie"
                            :key="item.titreCatégorie"
                          >
                            <v-expansion-panel-header>
                              <th>{{ item.titreCatégorie }}</th>
                              <th>{{ item.value1 }}</th>
                              <th>{{ item.value2 }}</th>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-simple-table>
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <th class="text-left">&nbsp;</th>
                                      <th class="text-left">&nbsp;</th>
                                      <th class="text-left">&nbsp;</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="item in categoriegarantie"
                                      :key="item.titreCatégorie"
                                    >
                                      <td>{{ item.titreCatégorie }}</td>
                                      <td>{{ item.titreCatégorie }}</td>
                                      <td>{{ item.titreCatégorie }}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!--  Pop up des Contrat-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog
            v-model="contractDialog"
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
          >
            <v-card tile>
              <v-toolbar flat dark color="#0482fb">
                <v-btn
                  
                  icon
                  dark
                  @click="closeContract"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title
                  >DAYO - IARD / Production / Contrat</v-toolbar-title
                >
                <v-spacer></v-spacer>

                <v-menu bottom right offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      
                      dark
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, i) in items"
                      :key="i"
                      @click="() => {}"
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
              <v-card-text>
                <!-- tool -->
                <div
                  v-if="contractModal && contractModal._id"
                  class="d-flex justify-between"
                >
                  <v-toolbar-items>
                    <v-row align="center" justify="space-around">
                      <v-btn
                        
                        tile
                        color="success"
                        class="mr-12"
                        @click="incorporationDialog = true"
                      >
                        <v-icon left> mdi-pencil </v-icon>
                        Incoporation
                      </v-btn>
                    </v-row>
                  </v-toolbar-items>

                  <v-toolbar-items>
                    <v-row align="center" justify="space-around">
                      <v-btn
                        
                        tile
                        color="success"
                        class="mr-12"
                        @click="withDrawModal = true"
                      >
                        <v-icon left> mdi-pencil </v-icon>
                        Retrait
                      </v-btn>
                    </v-row>
                  </v-toolbar-items>

                  <v-toolbar-items>
                    <v-row align="center" justify="space-around">
                      <v-btn
                        
                        tile
                        color="success"
                        class="mr-12"
                        @click="regulationDialog = true"
                      >
                        <v-icon left> mdi-pencil </v-icon>
                        Clause regulation
                      </v-btn>
                    </v-row>
                  </v-toolbar-items>
                  <v-toolbar-items>
                    <v-row align="center" justify="space-around">
                      <v-btn
                        
                        tile
                        color="success"
                        class="mr-12"
                        @click="pbDialog = true"
                      >
                        <v-icon left> mdi-pencil </v-icon>
                        Clause de pb
                      </v-btn>
                    </v-row>
                  </v-toolbar-items>
                  <v-toolbar-items>
                    <v-row align="center" justify="space-around">
                      <v-btn
                        
                        tile
                        color="success"
                        class="mr-12"
                        @click="coinsuranceDialog = true"
                      >
                        <v-icon left> mdi-pencil </v-icon>
                        Coassurance
                      </v-btn>
                    </v-row>
                  </v-toolbar-items>
                  <v-toolbar-items>
                    <v-row align="center" justify="space-around">
                      <v-btn
                        
                        tile
                        color="success"
                        class="mr-12"
                        @click="reasure = true"
                      >
                        <v-icon left> mdi-pencil </v-icon>
                        Réassurance
                      </v-btn>
                    </v-row>
                  </v-toolbar-items>
                  <v-toolbar-items>
                    <v-row align="center" justify="space-around">
                      <v-switch
                        class="mr-12"
                        v-model="switch1"
                        :label="`Contrat en: ${switch1.toString()}`"
                      ></v-switch>
                    </v-row>
                  </v-toolbar-items>
                </div>
                <h2 class="pt-8 pl-3">
                  Signature de contrat pour client JOHN DOE
                </h2>

                <v-container fluid>
                  <v-row align="center">
                    <v-col v-if="!contractModal._id" cols="12">
                      <v-select
                        outlined
                        :items="companyNameList"
                        v-model="contractModal.company"
                        label="Compagnie"
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        outlined
                        :items="CommercialNameList"
                        v-model="contractModal.commercial"
                        @change="select_value"
                        label="Commercial"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.policeNumber"
                        label="Numero de police"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.plugged"
                        label="Branche"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.category"
                        label="Catégorie"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.netPrime"
                        label="Prime nette"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.commission"
                        label="Commission"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.totalPrime"
                        label="Prime total"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.cdeaoPrime"
                        label="Prime CDEAO"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.accessory100"
                        @blur="seed50Accessory"
                        type="number"
                        label="Cout total police pour 100%"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.accessory50"
                        type="number"
                        label="Cout total police pour 50"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.effectDate"
                        type="date"
                        label="Effect"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.dueDate"
                        type="date"
                        label="Echeance"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        outlined
                        color="#0482fb"
                        v-model="contractModal.paymentDate"
                        type="date"
                        label="Date de paiement"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-textarea
                        outlined
                        name="input-7-4"
                        label="Observation"
                        v-model="contractModal.observation"
                        value=""
                      ></v-textarea>
                    </v-col>

                    <v-col cols="12">
                      <v-btn
                        
                        class="w-100 primary white--text"
                        @click="saveContract"
                      >
                        Enregistrer
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!-- New appels-->
    <v-dialog v-model="callDialog" max-width="500px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h5"> {{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  outlined
                  v-model="callModal.assignTo"
                  :items="userNameList"
                  attach
                  chips
                  label="Agent exécutant l'appel"
                  multiple
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="callModal.hour"
                  type="time"
                  label="Heure d'appel"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="callModal.date"
                  :value="callModal.date"
                  type="date"
                  label="Date d'appel"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  v-model="callModal.reason"
                  label="Motifs d'appel"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-select
                  outlined
                  v-model="callModal.done"
                  :items="this.itemsDone"
                  attach
                  chips
                  label="Appel effectué ?"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  v-if="callModal.done"
                  v-model="callModal.returnObservation"
                  label="Retour d'appel"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            
            :disabled="loading"
            color="error"
            text
            @click="closeCall"
          >
            Fermer
          </v-btn>
          <v-btn
            
            :loading="loading ? '#0482fb' : null"
            color="success"
            @click="saveCall"
          >
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- New appointment-->
    <v-dialog v-model="appointmentAddDialog" max-width="500px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  outlined
                  v-model="appointmentModal.assignTo"
                  :items="userNameList"
                  attach
                  chips
                  label="Agent exécutant"
                  multiple
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="appointmentModal.participants"
                  label="Ajouter les participants au rendez-vous"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="appointmentModal.location"
                  label="Lieu rendez-vous"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="appointmentModal.date"
                  type="date"
                  label="Date rendez-vous"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="appointmentModal.startPeriod"
                  type="time"
                  label="Heure rendez-vous début"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="appointmentModal.endPeriod"
                  type="time"
                  label="Heure rendez-vous fin"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  outlined
                  v-model="appointmentModal.reason"
                  label="Motifs rendez-vous"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-select
                  outlined
                  v-model="appointmentModal.done"
                  :items="this.itemsDone"
                  attach
                  chips
                  label="Rendez-vous effectué ?"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  v-if="appointmentModal.done"
                  v-model="appointmentModal.returnObservation"
                  label="Retour du rendez-vous"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            
            :disabled="loading"
            color="error darken-1"
            text
            @click="closeAppointment"
          >
            Fermer
          </v-btn>
          <v-btn
            
            :loading="loading ? '#0482fb' : null"
            color="success darken-1"
            @click="saveAppointment"
          >
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- incoporation -->
    <v-dialog v-model="incorporationDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Enregistrer incoporation</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="incorporationModal.fullName"
                  label="Nom complet"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  outlined
                  :items="['Masculin', 'Feminin']"
                  v-model="incorporationModal.sex"
                  label="Sex"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="incorporationModal.email"
                  label="Mail"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="incorporationModal.contact"
                  label="contact"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="incorporationModal.activity"
                  label="Activite"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="incorporationModal.birthday"
                  type="date"
                  label="Date Anniverssaire"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            
            color="error darken-1"
            @click="closeContract"
          >
            Retour
          </v-btn>
          <v-btn
            
            color="success darken-1"
            @click="saveIncorporation"
          >
            Effectuer incoporation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Retrait -->
    <v-dialog v-model="withDrawModal" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Effectuer un retrait</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  outlined
                  :items="prospectsNameList"
                  v-model="incorporationModal.name"
                  label="Nom de l'utilisateur"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            
            color="error darken-1"
            @click="(withDrawModal = false), (incorporationModal = {})"
          >
            Retour
          </v-btn>
          <v-btn
            
            color="success darken-1"
            :loading="loading ? '#0482fb' : null"
            @click="makeWithDraw"
          >
            Confirmer retrait
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- regulation clause -->
    <v-dialog v-model="regulationDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Effectuer une clause de régularisation</span>
        </v-card-title>
        <!-- {{ regulationClauseModal }} -->
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="regulationClauseModal.plate"
                  label="Assiette"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="regulationClauseModal.observation"
                  label="Observation"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <!-- <v-text-field outlined  
            color="#0482fb"
                  v-model="regulationClauseModal.reminderDate"
                  type="date"
                  label="Date de rapel"
                ></v-text-field> -->
                <v-menu
                  ref="reminderMenu1"
                  v-model="reminderMenu"
                  :close-on-content-click="false"
                  :return-value.sync="regulationClauseModal.reminderDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      v-model="regulationClauseModal.reminderDate"
                      label="Date de rapel"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="regulationClauseModal.reminderDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="reminderMenu = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="
                        $refs.reminderMenu1.save(
                          regulationClauseModal.reminderDate
                        )
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="6">
                <!-- <v-text-field outlined  
            color="#0482fb"
                  v-model="regulationClauseModal.companyRequestDate"
                  type="date"
                  label="Date envoi compagnie"
                ></v-text-field> -->

                <v-menu
                  ref="companyRequestMenu1"
                  v-model="companyRequestMenu"
                  :close-on-content-click="false"
                  :return-value.sync="regulationClauseModal.companyRequestDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      v-model="regulationClauseModal.companyRequestDate"
                      label="Date envoi compagnie"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="regulationClauseModal.companyRequestDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="companyRequestMenu = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="
                        $refs.companyRequestMenu1.save(
                          regulationClauseModal.companyRequestDate
                        )
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <!-- <v-text-field outlined  
            color="#0482fb"
                  v-model="regulationClauseModal.companyReturnDate"
                  type="date"
                  label="Date retour compagnie"
                ></v-text-field> -->

                <v-menu
                  ref="companyReturnMenu1"
                  v-model="companyReturnMenu"
                  :close-on-content-click="false"
                  :return-value.sync="regulationClauseModal.companyReturnDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      v-model="regulationClauseModal.companyReturnDate"
                      label="Date retour compagnie"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="regulationClauseModal.companyReturnDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="companyReturnMenu = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="
                        $refs.companyReturnMenu1.save(
                          regulationClauseModal.companyReturnDate
                        )
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <!-- <v-text-field outlined  
            color="#0482fb"
                  v-model="regulationClauseModal.customerRequestDate"
                  type="date"
                  label="Date envoi client"
                ></v-text-field> -->

                <v-menu
                  ref="customerRequestMenu1"
                  v-model="customerRequestMenu"
                  :close-on-content-click="false"
                  :return-value.sync="regulationClauseModal.customerRequestDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      v-model="regulationClauseModal.customerRequestDate"
                      label="Date envoi client"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="regulationClauseModal.customerRequestDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="customerRequestMenu = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="
                        $refs.customerRequestMenu1.save(
                          regulationClauseModal.customerRequestDate
                        )
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <!-- <v-text-field outlined  
            color="#0482fb"
                  v-model="regulationClauseModal.customerReturnDate"
                  type="date"
                  label="date retour client"
                ></v-text-field> -->

                <v-menu
                  ref="customerReturnMenu1"
                  v-model="customerReturnMenu"
                  :close-on-content-click="false"
                  :return-value.sync="regulationClauseModal.customerReturnDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      v-model="regulationClauseModal.customerReturnDate"
                      label="date retour client"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="regulationClauseModal.customerReturnDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="customerReturnMenu = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="
                        $refs.customerReturnMenu1.save(
                          regulationClauseModal.customerReturnDate
                        )
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            
            color="error darken-1"
            @click="closeClause"
          >
            Retour
          </v-btn>
          <v-btn
            
            color="success darken-1"
            @click="saveRegulation"
          >
            Confirmer regulation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- regulation PB -->
    <v-dialog v-model="pbDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Effectuer une clause de régularisation</span>
        </v-card-title>
        <!-- {{ regulationClauseModal }} -->
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="pbClauseModal.plate"
                  label="Assiette"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  outlined
                  color="#0482fb"
                  v-model="pbClauseModal.observation"
                  label="Observation"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <!-- <v-text-field outlined  
            color="#0482fb"
                  v-model="pbClauseModal.reminderDate"
                  type="date"
                  label="Date de rapel"
                ></v-text-field> -->
                <v-menu
                  ref="reminderMenu1"
                  v-model="reminderMenu"
                  :close-on-content-click="false"
                  :return-value.sync="pbClauseModal.reminderDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      v-model="pbClauseModal.reminderDate"
                      label="Date de rapel"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="pbClauseModal.reminderDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="reminderMenu = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="
                        $refs.reminderMenu1.save(pbClauseModal.reminderDate)
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="6">
                <!-- <v-text-field outlined  
            color="#0482fb"
                  v-model="pbClauseModal.companyRequestDate"
                  type="date"
                  label="Date envoi compagnie"
                ></v-text-field> -->

                <v-menu
                  ref="companyRequestMenu1"
                  v-model="companyRequestMenu"
                  :close-on-content-click="false"
                  :return-value.sync="pbClauseModal.companyRequestDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      v-model="pbClauseModal.companyRequestDate"
                      label="Date envoi compagnie"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="pbClauseModal.companyRequestDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="companyRequestMenu = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="
                        $refs.companyRequestMenu1.save(
                          pbClauseModal.companyRequestDate
                        )
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <!-- <v-text-field outlined  
            color="#0482fb"
                  v-model="pbClauseModal.companyReturnDate"
                  type="date"
                  label="Date retour compagnie"
                ></v-text-field> -->

                <v-menu
                  ref="companyReturnMenu1"
                  v-model="companyReturnMenu"
                  :close-on-content-click="false"
                  :return-value.sync="pbClauseModal.companyReturnDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      v-model="pbClauseModal.companyReturnDate"
                      label="Date retour compagnie"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="pbClauseModal.companyReturnDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="companyReturnMenu = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="
                        $refs.companyReturnMenu1.save(
                          pbClauseModal.companyReturnDate
                        )
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <!-- <v-text-field outlined  
            color="#0482fb"
                  v-model="pbClauseModal.customerRequestDate"
                  type="date"
                  label="Date envoi client"
                ></v-text-field> -->

                <v-menu
                  ref="customerRequestMenu1"
                  v-model="customerRequestMenu"
                  :close-on-content-click="false"
                  :return-value.sync="pbClauseModal.customerRequestDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      v-model="pbClauseModal.customerRequestDate"
                      label="Date envoi client"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="pbClauseModal.customerRequestDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="customerRequestMenu = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="
                        $refs.customerRequestMenu1.save(
                          pbClauseModal.customerRequestDate
                        )
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <!-- <v-text-field outlined  
            color="#0482fb"
                  v-model="pbClauseModal.customerReturnDate"
                  type="date"
                  label="date retour client"
                ></v-text-field> -->

                <v-menu
                  ref="customerReturnMenu1"
                  v-model="customerReturnMenu"
                  :close-on-content-click="false"
                  :return-value.sync="pbClauseModal.customerReturnDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      color="#0482fb"
                      v-model="pbClauseModal.customerReturnDate"
                      label="date retour client"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="pbClauseModal.customerReturnDate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="customerReturnMenu = false"
                    >
                      Annuler
                    </v-btn>
                    <v-btn
                      
                      text
                      color="primary"
                      @click="
                        $refs.customerReturnMenu1.save(
                          pbClauseModal.customerReturnDate
                        )
                      "
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            
            color="error darken-1"
            @click="closeClause"
          >
            Retour
          </v-btn>
          <v-btn
            
            color="success darken-1"
            @click="savePb"
          >
            Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Reassurance -->
    <v-dialog v-model="returnDate" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Retour demande cotation</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  color="#0482fb"
                  label="Date retour cotation"
                  v-model="datereturne"
                  type="date"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  color="#0482fb"
                  label="Date retour client"
                  v-model="customerReturnDate"
                  type="date"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            
            color="error darken-1"
            @click="returnDate = false"
          >
            Retour
          </v-btn>
          <v-btn
            
            color="success darken-1"
            @click="onConfirmQuotationRequestDate"
            >Enregistrer</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages, rules } from "@/utils/data";
import {
  addCall,
  updateCall,
  addAppointment,
  // updateFile,
  updateAppointment,
  addQuoting,
  updateQuoting,
  updateContract,
  addContract,
  addIncorporation,
  withdrawProspect,
  addRegulationClause,
  updateRegulationClause,
  addPbClause,
  updatePbClause,
  addCoinsurance,
  updateCoinsurance,
  createQuotingRequest,
  updateQuotingRequest,
} from "@/api/user.js";
import { updateFile } from "@/api/admin.js";
export default {
  name: "production",
  components: {},

  data() {
    return {
      defaultMethods,
      reminderMenu: false,
      companyRequestMenu: false,
      companyReturnMenu: false,
      customerRequestMenu: false,
      customerReturnMenu: false,
      rules,
      switch1: true,
      panel: [],
      tab: null,
      garantietitre: [
        {
          tab: "RESPONSABILITE CIVILE CHEF D'ENTREPRISE",
          content: "Tab 1 Content",
        },
        { tab: "MULTIRISQUE PROFESSIONNELLE", content: "Tab 2 Content" },
        { tab: "GLOBAL DE BANQUE BOA", content: "Tab 3 Content" },
        { tab: "MULTIRISQUE HABITATION", content: "Tab 4 Content" },
        { tab: "TRC", content: "Tab 5 Content" },
        { tab: "IND", content: "Tab 6 Content" },
      ],
      items: ["NSIA", "SANLAM", "SAHAM", "ATLANTIQUE ASSURANCE"],
      link: [
        {
          text: "Prospection",
          disabled: false,
          href: "/prospection",
        },
        {
          text: "Gestion dossier",
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
      natureprospect: ["Physics", "Entreprise"],
      quotingProduct: "",
      focus: "",
      focuss: "",
      search: "",
      events: [],
      type: "month",
      types: "month",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days",
      },
      select: "",
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      colors: ["red"],
      names: ["Appel"],
      colorss: ["green"],
      namess: ["Rendez vous"],
      categories: ["John Smith"],
      addgarantie: false,
      returnDate: false,
      dialog: false,
      appelsModal: false,
      callDialog: false,
      appointmentAddDialog: false,
      appointmentDialog: false,
      productDialog: false,
      quotingDialog: false,
      garantie: false,
      contractDialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      quotingModal: {},
      prospect: false,
      dialogDelete: false,
      categoriegarantie: [
        {
          titreCatégorie: "I- Responsabilité Civile Exploitation",
          value1: "",
          value2: "",
          Souscategoriegarantie: [
            {
              titreCatégorie: "domage",
              value1: "",
              value2: "",
            },
            {
              titreCatégorie: "domage",
              value1: "",
              value2: "",
            },
          ],
        },
        {
          titreCatégorie: "II- Responsabilité Civile Professionnelle",
          value1: "",
          value2: "",
          Souscategoriegarantie: [
            {
              titreCatégorie: "Domage1",
              value1: "",
              value2: "",
            },
          ],
        },
        {
          titreCatégorie: "III- Défense et Recours",
          value1: "10 000 000",
          value2: "Néant",
        },
      ],
      produitsugest: [
        {
          text: " Liste des produits",
          value: "name",
        },
      ],
      produittake: [
        {
          text: "Liste des produits Proposer",
          value: "nom",
        },
      ],

      headers: [
        {
          text: "Nom et Prénoms ",
          align: "start",
          sortable: false,
          value: "fullName",
        },
        { text: "Contact", value: "contact" },
        { text: "Mail", value: "email" },
        { text: "Date d'anniversaire", value: "birthday" },
        { text: "Type d'influence", value: "affluenceType" },

        // { text: "Actions", value: "actions", sortable: false },
      ],
      listproduit: [
        {
          name: "Cart d'identité",
        },
        {
          name: "permis de conduit",
        },
        {
          name: "Atestation de residence",
        },
      ],
      prospectdata: [],
      test: ["name"],
      editedIndex: -1,
      editedItem: {
        nom: "",
        Nature: "",
        Contact: "",
        Activité: "",
        Mail: "",
        Anniverssaire: "",
        Localisation: "",
      },
      defaultItem: {
        nom: "",
        Nature: "",
        Contact: "",
        Activité: "",
        Mail: "",
        Anniverssaire: "",
        Localisation: "",
      },
      incorporationDialog: false,
      withDrawModal: false,
      coinsuranceDialog: false,
      reasure: false,
      CotationDialog: false,
      returnCompagn: false,
      regulationDialog: false,
      pbDialog: false,

      email: "",
      emailRules: [
        (v) => !!v || "E-mail is ",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      callModal: {},
      appointmentModal: {},
      itemsDone: [
        {
          text: "Oui",
          value: true,
        },
        {
          text: "Non",
          value: false,
        },
      ],
      appointmentEvents: [],
      loading: false,
      valid: false,
      testMail: [],
      firstName: "",
      UserNames: [],

      headersProduct: [
        {
          text: "Nom du produit",
          align: "start",
          sortable: false,
          value: "name",
        },
        //  { text: "Abréviation", value: "acronym" },
        // { text: "Description", value: "description" },
        // { text: "Demande de cotation", value: "quotingRequest", sortable: false },
      ],
      cotingHeaders: [
        {
          text: "Nom du produit",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Date demande cotation", value: "acronym" },
        { text: "Date retour demande cotation", value: "description" },
        { text: "Date envoi client", value: "quotingRequest", sortable: false },
        { text: "Date retour client", value: "customerReturnDate" },
        { text: "Statut", value: "customerReturnDate" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      headersProposedProduct: [
        {
          text: "Nom du produit",
          align: "start",
          sortable: false,
          value: "name",
        },
        //{ text: "Abréviation", value: "acronym" },
        // { text: "Description", value: "description" },
        //{ text: "Demande de cotation", value: "quotingRequest", sortable: false },
        //{ text: "Date retour client", value: "customerReturnDate" },
        //{ text: "Actions", value: "actions", sortable: false },
      ],
      selectedProduct: {},
      currentProduct: null,

      proposedProductNameList: [],
      companyNameList: [],
      coinsuranceCompanyNameList: [],
      CommercialNameList: [],
      userNameList: [],
      prospectsNameList: [],

      contractModal: {
        accessory100: 0,
        accessory50: 0,
      },
      incorporationModal: {},
      regulationClauseModal: {
        reminderDate: "",
        companyRequestDate: "",
        companyReturnDate: "",
        customerRequestDate: "",
        customerReturnDate: "",
      },
      pbClauseModal: {
        reminderDate: "",
        companyRequestDate: "",
        companyReturnDate: "",
        customerRequestDate: "",
        customerReturnDate: "",
      },

      coinsuranceModal: [
        {
          shareRate: 0,
          company: "",
          observation: "",
        },
      ],
      proposedProductId: null,
      usersEmail: [],
    };
  },

  mounted() {
    this.initFile();

    this.$refs.calendar.checkChange();
    this.$refs.calendars.checkChange();
  },
  computed: {
    ...mapGetters([
      "File",
      "Products",
      "Companies",
      "Quoting",
      "Users",
      "Contract",
    ]),
    formTitle() {
      return this.editedIndex === -1 ? "Programmer" : "Modifier";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    File() {
      this.seedProposedProduct();

      //  prospects name liste

      this.prospectsNameList = defaultMethods.getNameList(this.File.prospects);
      // get contract
      this.seedContract();
      this.getCallEvent();
      this.getAppointmentEvent();
    },
    contractModal() {},
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      this.seedCoinsuranceCompanyNameList();
    },
    Users() {
      this.userNameList = defaultMethods.getNameList(this.Users.docs);
    },
    Quoting() {
      if (this.Quoting && this.Quoting._id) {
        this.quotingModal = this.Quoting;
        this.quotingModal.companies = defaultMethods.getItemsName(
          this.Companies.docs,
          this.Quoting.companies
        );
      }
    },

    currentProduct() {
      if (this.currentProduct !== null) {
        // get quoting

        // get contract
        this.seedContract();
      }
    },
    Contract() {
      if (this.Contract) {
        this.contractModal = this.Contract;
        this.contractModal.company = defaultMethods.getItemName(
          this.Companies.docs,
          this.contractModal.company
        );
        this.contractModal.commercial = defaultMethods.getItemName(
          this.Users.docs,
          this.contractModal.commercial
        );

        this.contractModal.dueDate = defaultMethods.getDateFormat(
          this.contractModal.dueDate
        );
        this.contractModal.effectDate = defaultMethods.getDateFormat(
          this.contractModal.effectDate
        );
        this.contractModal.paymentDate = defaultMethods.getDateFormat(
          this.contractModal.paymentDate
        );

        if (this.Contract.otherInfo) {
          // clause regulation
          if (this.Contract.otherInfo.regulationClause) {
            this.regulationClauseModal = this.Contract.otherInfo.regulationClause;
          }

          // pb clause
          // clause regulation
          if (this.Contract.otherInfo.pbClause) {
            this.pbClauseModal = this.Contract.otherInfo.pbClause;
          }

          // coinsurance
          if (this.Contract.otherInfo.coinsurance) {
            this.coinsuranceModal = this.Contract.otherInfo.coinsurance;
            for (let i = 0; i < this.coinsuranceModal.length; i++) {
              this.coinsuranceModal[i].company = defaultMethods.getItemName(
                this.Companies.docs,
                this.coinsuranceModal[i].company
              );
            }
          }
        }
      } else {
        this.contractModal = {
          accessory100: 0,
          accessory50: 0,
        };
      }
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions([
      "getFile",
      "getProducts",
      "getCompanies",
      "getQuoting",
      "getUsers",
      "getContract",
    ]),
    initialize() {
      this.prospectdata = [
        {
          nom: "Koudenou Jean Baptiste",
          Nature: "Physique",
          Contact: "62144455 / 22335747",
          Activité: "Député",
          Mail: "Jean95@test.com",
          Localisation: "CNSAD",
          Anniverssaire: "22/08/2000",
        },
        {
          nom: "Koudenou Jean Baptiste",
          Nature: "Physique",
          Contact: "62144455 / 22335747",
          Activité: "Député",
          Mail: "Jean95@test.com",
          Localisation: "CNSAD",
          Anniverssaire: "22/08/2000",
        },
      ];
    },

    onGetConfirmQuotationRequestDate(item) {
      this.proposedProductId = item.quotingRequestId;
      this.returnDate = true;
      this.datereturne = item.quotingRequestReturnDate;
      this.customerReturnDate = item.customerReturnDate;
    },
    async onConfirmQuotationRequestDate() {
      const res = await updateQuotingRequest({
        schema: {
          returnDate: this.datereturne,
          customerReturnDate: this.customerReturnDate,
        },
        id: this.proposedProductId,
      });

      if (res.success) {
        defaultMethods.dispatchSuccess(this.$store, res.message);
        await this.getFile(this.$route.params.id);
      } else {
        defaultMethods.dispatchError(this.$store);
      }
      this.returnDate = false;
    },
    // files
    searchDataProduct() {
      this.initFile();
    },
    async initFile() {
      this.loading = true;
      try {
        await this.getFile(this.$route.params.id);
        await this.getProducts({ name: this.searchData });
        await this.getCompanies();
        await this.getUsers();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    closeCall() {
      this.callModal = {};
      this.callDialog = false;
      // this.appelsModal = false;
    },
    // call
    async saveCall() {
      this.loading = true;
      try {
        //alert(this.callModal.assignTo);
        const schema = {
          assignTo: defaultMethods.getItemsId(
            this.Users.docs,
            this.callModal.assignTo
          ),
          reason: this.callModal.reason,
          hour: this.callModal.hour,
          date: this.callModal.date,
          returnObservation: this.callModal.returnObservation,
          done: this.callModal.done,
        };

        if (this.callModal._id) {
          // update ,
          await updateCall({
            schema,
            id: this.callModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Call")
          );
          this.closeCall();
          this.initFile();
        } else {
          // add
          // console.log(schema);
          await addCall({ schema, id: this.$route.params.id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Appel")
          );
          this.closeCall();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // quoting request
    async makeQuotingRequest(id) {
      try {
        await createQuotingRequest({
          schema: { file: this.File._id, product: id },
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.createdSuccessfully("Quoting request")
        );
        this.closeProduct();
        this.initFile();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
    },
    // quoting
    async saveQuoting() {
      this.loading = true;

      try {
        const schema = {
          companies: defaultMethods.getItemsId(
            this.Companies.docs,
            this.quotingModal.companies
          ),

          product: defaultMethods.getItemId(
            this.File.proposedProducts,
            this.currentProduct
          ),
          duration: this.quotingModal.duration,
          netPrime: this.quotingModal.netPrime,
          TTCPrime: this.quotingModal.TTCPrime,
          annualRent: this.quotingModal.annualRent,
          // dateReturnCustomer: this.quotingModal.dateReturnCustomer,
          turnover: this.quotingModal.turnover,
          effective: this.quotingModal.effective,
          quality: this.quotingModal.quality,
          payroll: this.quotingModal.payroll,
          siteType: this.quotingModal.siteType,
          observation: this.quotingModal.observation,
          file: this.File._id,
        };

        if (this.quotingModal.dateReturnCustomer) {
          schema.dateReturnCustomer = this.quotingModal.dateReturnCustomer;
        }
        if (this.quotingModal._id) {
          // update
          await updateQuoting({
            schema,
            id: this.quotingModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeQuoting();
          this.initFile();
        } else {
          // add
          await addQuoting({ schema, id: this.$route.params.id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Appel")
          );
          this.closeQuoting();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    async saveQuotingRequest() {
      this.loading = true;
      try {
        const schema = {
          product: defaultMethods.getItemId(
            this.File.proposedProducts,
            this.product
          ),
          emails: defaultMethods.getItemsEmail(
            this.Users.docs,
            this.usersEmail
          ),
          observation: this.observation,
          file: this.File._id,
        };

        // add
        await createQuotingRequest({ schema });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.createdSuccessfully("Demande cotation")
        );

        this.CotationDialog = false;
        this.product = null;
        this.observation = null;
        this.CommercialNameList = null;
        this.initFile();
      } catch (error) {
        console.log(error);

        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    closeQuoting() {
      this.quotingModal = {};
      this.quotingDialog = false;
      this.currentProduct = null;
    },
    async initQuoting() {
      try {
        this.loading = true;

        await this.getQuoting({
          product: defaultMethods.getItemId(
            this.File.proposedProducts,
            this.currentProduct
          ),
        });
        this.loading = false;
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },

    select_value() {
      // get quoting
      this.initQuoting();
      // get guarentie
      // get contract
    },

    // contract
    async seedContract() {
      this.loading = true;
      try {
        if (this.File && this.File._id && this.currentProduct) {
          await this.getContract({
            id: this.File._id,
            product: defaultMethods.getItemId(
              this.File.proposedProducts,
              this.currentProduct
            ),
          });
        } else {
          this.Contract = {};
          this.contractModal = {};
        }
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    seed50Accessory() {
      if (
        this.contractModal.accessory100 &&
        Number(this.contractModal.accessory100) > 0
      ) {
        this.contractModal.accessory50 = this.contractModal.accessory100 / 2;
      }
    },
    async saveContract() {
      this.loading = true;
      try {
        const schema = {
          policeNumber: this.contractModal.policeNumber,
          plugged: this.contractModal.plugged,
          category: this.contractModal.category,
          company: defaultMethods.getItemId(
            this.Companies.docs,
            this.contractModal.company
          ),
          commercial: defaultMethods.getItemId(
            this.Users.docs,
            this.contractModal.commercial
          ),
          effectDate: this.contractModal.effectDate,
          dueDate: this.contractModal.dueDate,
          paymentDate: this.contractModal.paymentDate,
          netPrime: this.contractModal.netPrime,
          commission: this.contractModal.commission,
          totalPrime: this.contractModal.totalPrime,
          cdeaoPrime: this.contractModal.cdeaoPrime,
          observation: this.contractModal.observation,
          accessory100: this.contractModal.accessory100,
          accessory50: this.contractModal.accessory100 / 2,
        };

        if (this.contractModal._id) {
          // update
          await updateContract({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        } else {
          // add
          schema.product = defaultMethods.getItemId(
            this.File.proposedProducts,
            this.currentProduct
          );
          schema.file = this.File._id;
          await addContract({ schema, id: this.$route.params.id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeClause() {
      this.regulationDialog = false;
      this.pbDialog = false;
    },
    closeContract() {
      this.contractDialog = false;
      this.contractModal = {
        accessory100: 0,
        accessory50: 0,
      };
      this.currentProduct = null;
      this.incorporationDialog = false;
      this.incorporationModal = {};
      this.withDrawModal = false;
      this.regulationDialog = false;
      this.pbDialog = false;
    },

    // incorporation
    async saveIncorporation() {
      this.loading = true;
      try {
        // add

        await addIncorporation({
          schema: {
            contract: this.contractModal._id,
            prospect: this.incorporationModal,
          },
          id: this.File._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.createdSuccessfully("Incorporation")
        );
        this.closeContract();
        this.initFile();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // retrait
    async makeWithDraw() {
      this.loading = true;
      try {
        await withdrawProspect({
          schema: {
            contract: this.contractModal._id,
            prospect: defaultMethods.getItemId(
              this.File.prospects,
              this.incorporationModal.name
            ),
          },
          id: this.File._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.createdSuccessfully("Incorporation")
        );
        this.closeContract();
        this.initFile();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    async saveRegulation() {
      this.loading = true;
      try {
        const schema = {
          plate: this.regulationClauseModal.plate,
          reminderDate: this.regulationClauseModal.reminderDate,
          observation: this.regulationClauseModal.observation,
          companyRequestDate: this.regulationClauseModal.companyRequestDate,
          companyReturnDate: this.regulationClauseModal.companyReturnDate,
          customerRequestDate: this.regulationClauseModal.customerRequestDate,
          customerReturnDate: this.regulationClauseModal.customerReturnDate,
        };

        if (this.regulationClauseModal._id) {
          // update
          await updateRegulationClause({
            schema,
            id: this.regulationClauseModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        } else {
          // add

          await addRegulationClause({ schema, id: this.contractModal._id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    async savePb() {
      this.loading = true;
      try {
        const schema = {
          plate: this.pbClauseModal.plate,
          reminderDate: this.pbClauseModal.reminderDate,
          observation: this.pbClauseModal.observation,
          companyRequestDate: this.pbClauseModal.companyRequestDate,
          companyReturnDate: this.pbClauseModal.companyReturnDate,
          customerRequestDate: this.pbClauseModal.customerRequestDate,
          customerReturnDate: this.pbClauseModal.customerReturnDate,
        };

        if (this.pbClauseModal._id) {
          // update
          await updatePbClause({
            schema,
            id: this.pbClauseModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        } else {
          // add

          await addPbClause({ schema, id: this.contractModal._id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    setTodays() {
      this.focuss = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    prevs() {
      this.$refs.calendars.prev();
    },
    nexts() {
      this.$refs.calendars.next();
    },
    showCallEvent({ nativeEvent, event }) {
      const edit = async () => {
        this.callModal = {
          _id: event._id,
          assignTo: event.assignTo,
          reason: event.name,
          hour: event.hour,
          date: event.date,
          done: event.done,
          returnObservation: event.returnObservation,
        };
        this.editedIndex = 1;
        // this.ModalText = {
        //   btn: "update",
        //   title: `Update ${this.program.type}`,
        // };
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.callDialog = true))
        );
      };

      if (this.callDialog) {
        this.closeCall();
        requestAnimationFrame(() => requestAnimationFrame(() => edit()));
      } else {
        edit();
      }

      nativeEvent.stopPropagation();
    },
    getCallEvent() {
      this.events = [];

      if (!this.File || !this.File.otherInfo || !this.File.otherInfo.calls)
        return;
      for (let i = 0; i < this.File.otherInfo.calls.length; i++) {
        const program = this.File.otherInfo.calls[i];
        const progDate = program.date;
        //console.log(program.assignTo);
        const assignTo = defaultMethods.getNameList(program.assignTo);
        const date = new Date(`${program.date}`);
        const hours = program.hour.split(":");
        date.setHours(hours[0]);
        date.setMinutes(hours[1]);
        this.events.push({
          name: program.reason,
          start: date,
          end: date,
          date: progDate,
          assignTo: assignTo,
          color: "red",
          timed: true,
          hour: program.hour,
          done: program.done,
          returnObservation: program.returnObservation,
          _id: program._id,
        });
      }
    },

    // appointment
    showAppointmentEvent({ nativeEvent, event }) {
      const edit = async () => {
        this.appointmentModal = {
          _id: event._id,
          reason: event.name,
          assignTo: event.assignTo,
          startPeriod: event.startPeriod,
          participants: event.participants,
          endPeriod: event.endPeriod,
          hour: event.hour,
          location: event.location,
          date: event.date,
          done: event.done,
          returnObservation: event.returnObservation,
        };

        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.appointmentAddDialog = true))
        );
      };

      if (this.appointmentAddDialog) {
        this.closeAppointment();
        requestAnimationFrame(() => requestAnimationFrame(() => edit()));
      } else {
        edit();
      }

      nativeEvent.stopPropagation();
    },
    closeAppointment() {
      this.appointmentModal = {};
      this.appointmentAddDialog = false;
      // this.appointmentDialog = false;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    viewDays({ date }) {
      this.focuss = date;
      this.types = "day";
    },
    getAppointmentEvent() {
      this.appointmentEvents = [];

      if (
        !this.File ||
        !this.File.otherInfo ||
        !this.File.otherInfo.appointments
      )
        return;
      for (let i = 0; i < this.File.otherInfo.appointments.length; i++) {
        const program = this.File.otherInfo.appointments[i];

        const progDate = program.date;
        const assignTo = defaultMethods.getNameList(program.assignTo);
        const startPeriod = program.period.start;
        const endPeriod = program.period.end;
        //alert(program.period.start)
        const date = new Date(`${program.date}`);
        const dates = new Date(`${program.date}`);
        const hours = program.period.start.split(":");
        //alert(startPeriod)
        date.setHours(hours[0]);
        date.setMinutes(hours[1]);
        const hourss = program.period.end.split(":");

        dates.setHours(hourss[0]);
        dates.setMinutes(hourss[1]);
        this.appointmentEvents.push({
          name: program.reason,
          location: program.location,
          assignTo: assignTo,
          date: progDate,
          start: date,
          end: dates,
          endPeriod: endPeriod,
          participants: program.participants,
          hour: program.hour,
          startPeriod: startPeriod,
          done: program.done,
          returnObservation: program.returnObservation,
          color: "blue",
          timed: true,
          _id: program._id,
        });
        console.log(this.appointmentEvents);
      }
    },
    async saveAppointment() {
      this.loading = true;
      try {
        const schema = {
          assignTo: defaultMethods.getItemsId(
            this.Users.docs,
            this.appointmentModal.assignTo
          ),
          reason: this.appointmentModal.reason,
          participants: this.appointmentModal.participants,
          startPeriod: this.appointmentModal.startPeriod,
          endPeriod: this.appointmentModal.endPeriod,
          date: this.appointmentModal.date,
          hour: this.appointmentModal.startPeriod,
          location: this.appointmentModal.location,
          returnObservation: this.appointmentModal.returnObservation,
          done: this.appointmentModal.done,
        };
        if (this.appointmentModal._id) {
          // update
          await updateAppointment({
            schema,
            id: this.appointmentModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeAppointment();
          this.initFile();
        } else {
          // add
          await addAppointment({
            schema,
            id: this.$route.params.id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Rendez-vous")
          );
          this.closeAppointment();

          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // proposed product
    async updateProposedProduct() {
      try {
        const schema = {
          schema: {
            name: this.File.name,
            prospects: this.File.prospects,
            phone: this.File.phone,
            email: this.File.email,
            nature: this.File.nature,
            location: this.File.location,
            description: this.File.description,
            activityField: this.File.activityField,
            birthday: this.File.birthday,
            proposedProducts: defaultMethods.getIdList(this.selectedProduct),
          },
          id: this.File._id,
        };

        await updateFile(schema);
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Dossier")
        );
        //this.closeProduct();
        this.initFile();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
    },
    closeProduct() {
      this.productDialog = false;
      this.selectedProduct = {};
    },

    seedProposedProduct() {
      this.selectedProduct = this.File.proposedProducts;
      this.proposedProductNameList = defaultMethods.getNameList(
        this.File.proposedProducts
      );
    },

    // coinsurance
    seedCoinsuranceCompanyNameList() {
      this.coinsuranceCompanyNameList = defaultMethods.getNameList(
        this.Companies.docs
      );
    },
    updateCoinsuranceCompanyNameList() {
      // seed
      this.seedCoinsuranceCompanyNameList();
      console.log("here", this.coinsuranceModal);
      for (let a = 0; a < this.coinsuranceModal.lenght; a++) {
        const coinsurance = this.coinsuranceModal[a];
        for (let i = 0; i < this.coinsuranceCompanyNameList.lenght; i++) {
          console.log(coinsurance.company, this.coinsuranceCompanyNameList[i]);
          if (coinsurance.company == this.coinsuranceCompanyNameList[i])
            this.coinsuranceCompanyNameList.splice(i, 1);
        }
      }
    },
    addOneCoinsurance() {
      this.coinsuranceModal.push({});
    },
    closeInsurance() {
      this.coinsuranceDialog = false;
      this.currentProduct = null;
      this.contractDialog = false;

      this.coinsuranceModal = [
        {
          shareRate: 0,
          company: "",
          observation: "",
        },
      ];
      this.seedCoinsuranceCompanyNameList();
    },
    removeFromCoin(id) {
      // id -= 1;
      this.coinsuranceModal.splice(id, 1);
      this.seedCoinsuranceCompanyNameList();
    },
    async saveCoinsurance() {
      this.loading = true;
      try {
        // we need validate data
        const result = this.validCoinsuranceData(this.coinsuranceModal);
        console.log(result);
        if (!result.success)
          return defaultMethods.dispatchError(this.$store, result.message);

        const schema = {
          data: result.data,
        };
        if (this.coinsuranceModal[0]._id) {
          // update
          await updateCoinsurance({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("coassurance")
          );
          this.closeInsurance();
          this.initFile();
        } else {
          // add
          await addCoinsurance({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("coassurance")
          );
          this.closeInsurance();

          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    validCoinsuranceData(array) {
      const result = [];
      let totalRate = 0;

      const companyList = [];
      for (let i = 0; i < array.length; i++) {
        const item = array[i];

        // body validation

        // rate
        totalRate += Number(item.shareRate);

        // company
        if (companyList.includes(JSON.stringify(item.company)))
          throw new Error(
            `Duplicate company id  :${item.company} for coinsurance`
          );
        companyList.push(JSON.stringify(item.company));

        // get company id
        (item.company = defaultMethods.getItemId(
          this.Companies.docs,
          item.company
        )),
          result.push({
            shareRate: item.shareRate,
            company: item.company,
            isPayed: item.isPayed,
            observation: item.observation,
          });
      }

      if (totalRate !== 100)
        return {
          success: false,
          message: `Total shared rate must be 100,got ${totalRate}`,
        };

      return {
        success: true,
        data: result,
      };
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    addprospect(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.prospect = true;
    },
    updateprospect(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.prospect = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    onSave() {},

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.prospectdata[this.editedIndex], this.editedItem);
      } else {
        this.prospectdata.push(this.editedItem);
      }
      this.close();
    },
  },
};
</script>

<style scoped></style>
